<template>
  <a v-if="isExternalLink" :href="to" target="_blank" rel="noopener">
    <slot />
  </a>

  <NuxtLink v-else-if="isOwn" :to="to">
    <slot />
  </NuxtLink>

  <a
    v-else
    :href="to"
    :class="{ 'router-link-active': isActive, 'router-link-exact-active': isExactActive }"
  >
    <slot />
  </a>
</template>

<script setup lang="ts">
  /**
   * Ссылка через границу приложений: внешняя - <a target="_blank">,
   * своя - NuxtLink, чужая - <a href> с полной перезагрузкой.
   * @see ~/composables/use-app-zones.ts - реестр зон и isOwnRoute
   */
  import { getPathname } from '~/shared/const/app-routes'
  import { useAppZones } from '~/composables/use-app-zones'

  interface Props {
    /** Путь ('/news') или абсолютный URL (https:, mailto:, tel:) */
    to: string
  }

  const EXTERNAL_URL_PATTERN = /^(https?:|mailto:|tel:)/

  const props = defineProps<Props>()
  const route = useRoute()
  const { isOwnRoute } = useAppZones()

  const isExternalLink = computed(() => EXTERNAL_URL_PATTERN.test(props.to))
  const isOwn = computed(() => isOwnRoute(props.to))

  const targetPath = computed(() => getPathname(props.to))
  const isExactActive = computed(() => route.path === targetPath.value)
  const isActive = computed(
    () =>
      isExactActive.value
      || (targetPath.value !== '/' && route.path.startsWith(`${targetPath.value}/`)),
  )
</script>
